import * as types from './meetings-info.types';

export const meetingsInfoPageSelectors: types.IMeetingsInfoPageSelectors = {
  selectReducedMeetingsInfo: (state) => state.page.meetingsInfo.reducedMeetingsInfo,
  selectIsFetched: (state) => state.page.meetingsInfo.isFetched,
};
